'use strict';

require('klarna/klarnaOsm');